const downloadLink = (url)=> {
    const link = document.createElement('a')
    link.href = url
    link.click()
}

export { downloadLink };